var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUpFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98076 11.5373L10.3549 9.16314C10.7124 8.80564 11.2899 8.80564 11.6474 9.16314L14.0216 11.5373C14.5991 12.1148 14.1866 13.1048 13.3708 13.1048H8.62242C7.80659 13.1048 7.40326 12.1148 7.98076 11.5373Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpFilledIcon);
export default __webpack_public_path__ + "static/media/ChevronUpFilledIcon.354760967e3aad1bdf9984ea98eaffac.svg";
export { ForwardRef as ReactComponent };